import { t } from "ttag";

import { DocumentUploads } from "@/app/components/legacy-components";
import { DOCUMENT_FOLDER } from "@/shared/models/legacy-constants";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Dialog, FolderCheckIcon } from "@/shared/ui";

export const MedicalRecordUploadsModal = ({ show, onClose }: ModalProps) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={FolderCheckIcon}>
          <Dialog.Title>{t`Add medical records`}</Dialog.Title>
        </Dialog.Header>

        <DocumentUploads
          folder={DOCUMENT_FOLDER.OTHER}
          onCancel={onClose}
          onSuccess={onClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  );
};
